export interface AnimeEpisode {
  num: number;
  title: string;
  date: string;
}

export interface AnimeArticle {
  slug: string;
  id: number;
  title: string;
  alias: string;
  category: string;
  categorySlug: string;
  description: string;
  longDescription: string;
  rating: number;
  studio: string;
  author: string;
  status: string;
  updateDay: string;
  updateTime: string;
  totalEpisodes: number;
  currentEpisode: number;
  episodes: AnimeEpisode[];
  image: string;
  bannerImage: string;
  tags: string[];
}

const episodes1: AnimeEpisode[] = Array.from({ length: 20 }, (_, i) => ({
  num: 168 - i,
  title: `第${168 - i}集 ${['萧家试炼', '药老现身', '斗之气旋', '纳兰嫣然', '三年之约', '云岚宗', '黑角域', '迦南学院', '陨落心炎', '美杜莎女王', '丹会大比', '魂殿来袭', '斗圣遗迹', '古帝洞府', '双帝之战', '新的征程', '丹塔风云', '星陨阁', '天府联盟', '魂天帝'][i % 20]}`,
  date: `2026-${String(7 - Math.floor(i / 4)).padStart(2, '0')}-${String(((i * 3 + 1) % 28) + 1).padStart(2, '0')}`,
}));

const episodes2: AnimeEpisode[] = Array.from({ length: 15 }, (_, i) => ({
  num: 182 - i,
  title: `第${182 - i}集 ${['至尊骨重生', '石村风云', '荒域试炼', '柳神庇护', '鲲鹏宝术', '上界天骄', '九天十地', '仙古遗迹', '不朽之王', '独断万古', '他化自在', '界海之战', '命运之轮', '轮回之路', '永恒国度'][i % 15]}`,
  date: `2026-${String(7 - Math.floor(i / 4)).padStart(2, '0')}-${String(((i * 4 + 2) % 28) + 1).padStart(2, '0')}`,
}));

const episodes3: AnimeEpisode[] = Array.from({ length: 12 }, (_, i) => ({
  num: 96 - i,
  title: `第${96 - i}集 ${['灵根测试', '黄枫谷', '血色试炼', '筑基丹', '乱星海', '元婴之争', '灵界飞升', '大乘之路', '仙界篇', '掌天瓶', '轮回之秘', '道祖之境'][i % 12]}`,
  date: `2026-${String(7 - Math.floor(i / 4)).padStart(2, '0')}-${String(((i * 5 + 3) % 28) + 1).padStart(2, '0')}`,
}));

const makeEpisodes = (start: number, count: number, titles: string[]): AnimeEpisode[] =>
  Array.from({ length: count }, (_, i) => ({
    num: start - i,
    title: `第${start - i}集 ${titles[i % titles.length]}`,
    date: `2026-${String(7 - Math.floor(i / 4)).padStart(2, '0')}-${String(((i * 3 + 7) % 28) + 1).padStart(2, '0')}`,
  }));

export const allArticles: AnimeArticle[] = [
  {
    slug: 'doupo-cangqiong',
    id: 1,
    title: '斗破苍穹',
    alias: 'Battle Through the Heavens',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '天才少年萧炎骤然跌落神坛，却在机缘巧合下拜师药老，重燃斗志踏上修炼之路。六年之约，莫欺少年穷！',
    longDescription: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启！这里是属于斗气的世界，没有花俏艳丽的魔法，有的，仅仅是繁衍到巅峰的斗气！萧炎重新苦修，在药老的帮助下于迦南学院中收服异火，参加丹会大比夺魁，一步步走向斗气大陆的巅峰。',
    rating: 9.5,
    studio: '腾讯视频',
    author: '天蚕土豆',
    status: '连载中',
    updateDay: '周六',
    updateTime: '10:00',
    totalEpisodes: 208,
    currentEpisode: 168,
    episodes: episodes1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20fantasy%20scene%20with%20young%20flame%20warrior%20in%20red%20robes%20standing%20on%20mountain%20cliff%2C%20golden%20fiery%20aura%20surrounding%20him%2C%20dramatic%20epic%20lighting%20with%20warm%20crimson%20tones%2C%20stylized%20illustration%2C%20clean%20dark%20gradient%20background&width=800&height=500&seq=article-btth-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20wide%20Chinese%20anime%20fantasy%20banner%20with%20warrior%20silhouettes%20in%20ancient%20oriental%20battlefield%2C%20massive%20flame%20dragon%20in%20sky%2C%20dramatic%20warm%20golden%20and%20crimson%20lighting%2C%20cinematic%20composition%2C%20stylized%20donghua%20art%2C%20clean%20atmospheric%20background&width=1400&height=500&seq=article-btth-banner&orientation=landscape',
    tags: ['玄幻', '热血', '年番', '国产'],
  },
  {
    slug: 'wanmei-shijie',
    id: 2,
    title: '完美世界',
    alias: 'Perfect World',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '石昊自幼被夺走至尊骨，却不屈命运安排，凭借顽强意志一步步成为荒天帝，谱写一段独断万古的传奇。',
    longDescription: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？！一个少年从大荒中走出，一切从这里开始……少年石昊自幼被夺走至尊骨，在石村中逐渐成长，修炼至尊宝术，与各路天骄争锋，一步步跨越九天十地，最终成就独断万古的荒天帝之名。',
    rating: 9.3,
    studio: '腾讯视频',
    author: '辰东',
    status: '连载中',
    updateDay: '周日',
    updateTime: '10:00',
    totalEpisodes: 220,
    currentEpisode: 182,
    episodes: episodes2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20young%20hero%20with%20ancient%20armor%20and%20glowing%20rune%20tattoos%20standing%20in%20mystical%20forest%2C%20golden%20energy%20aura%20surrounding%20him%2C%20dramatic%20warm%20lighting%20with%20emerald%20accents%2C%20stylized%20anime%20art%2C%20clean%20ethereal%20background&width=800&height=500&seq=article-pw-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20wide%20Chinese%20donghua%20fantasy%20banner%20with%20ancient%20mystical%20forest%20and%20floating%20mountains%2C%20golden%20energy%20streams%20in%20sky%2C%20warm%20dramatic%20lighting%2C%20stylized%20illustration%2C%20clean%20atmospheric%20composition&width=1400&height=500&seq=article-pw-banner&orientation=landscape',
    tags: ['仙侠', '热血', '年番', '国产'],
  },
  {
    slug: 'fanren-xiuxian-zhuan',
    id: 3,
    title: '凡人修仙传',
    alias: 'A Record of a Mortal\'s Journey to Immortality',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '平凡少年韩立出身贫寒，凭借坚定心智与过人智慧，在尔虞我诈的修仙世界中杀出一条血路，步步登仙。',
    longDescription: '一个普通的山村穷小子，偶然之下进入江湖小门派，虽然资质平庸，但依靠自身努力和合理算计修炼成仙。韩立出身贫寒，为改善家境加入七玄门，从黄枫谷到乱星海，再从灵界到仙界，在尔虞我诈、弱肉强食的修仙世界中，依靠谨慎的性格和掌天瓶的奇遇，一步步踏上巅峰。这部作品以其严谨的修炼体系、环环相扣的剧情和深刻的人性刻画，被誉为国产修仙动漫的里程碑之作。',
    rating: 9.6,
    studio: '哔哩哔哩',
    author: '忘语',
    status: '连载中',
    updateDay: '周五',
    updateTime: '12:00',
    totalEpisodes: 120,
    currentEpisode: 96,
    episodes: episodes3,
    image: 'https://readdy.ai/api/search-image?query=Serene%20Chinese%20cultivation%20donghua%20scholar%20in%20flowing%20cyan%20robes%20holding%20jade%20slip%2C%20floating%20spirit%20lights%20around%2C%20misty%20mountain%20background%2C%20elegant%20stylized%20art%2C%20clean%20minimal%20composition%2C%20warm%20soft%20lighting&width=800&height=500&seq=article-frxxz-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20cultivation%20donghua%20banner%20with%20lone%20immortal%20cultivator%20standing%20on%20cloud%20peak%20overlooking%20vast%20mountain%20range%2C%20ethereal%20mist%2C%20soft%20golden%20sunlight%2C%20stylized%20cinematic%20art%2C%20clean%20serene%20atmosphere&width=1400&height=500&seq=article-frxxz-banner&orientation=landscape',
    tags: ['修仙', '智斗', '经典', '国产'],
  },
  {
    slug: 'zhetian',
    id: 4,
    title: '遮天',
    alias: 'Shrouding the Heavens',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '叶凡从地球穿越到北斗星域，在浩瀚宇宙中开启一段波澜壮阔的修仙之旅，登天路，踏歌行。',
    longDescription: '冰冷与黑暗并存的宇宙深处，九具庞大的龙尸拉着一口青铜古棺，亘古长存。一个普通的地球青年叶凡，在参加同学聚会时被青铜古棺带到了浩瀚的北斗星域。在这片神秘的土地上，他踏上修炼之路，登天路、踏歌行，弹指遮天。从荒古禁地到不死山，从神墟到太初古矿，叶凡一步步揭开宇宙最深处的秘密。',
    rating: 9.2,
    studio: '腾讯视频',
    author: '辰东',
    status: '连载中',
    updateDay: '周三',
    updateTime: '10:00',
    totalEpisodes: 104,
    currentEpisode: 58,
    episodes: makeEpisodes(58, 12, ['荒古禁地', '九龙拉棺', '虚空经', '不死神药', '黑暗动乱', '大成圣体', '轮回海', '葬天岛', '仙路尽头', '天帝之位', '万族盛会', '星空古路']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20donghua%20celestial%20warrior%20with%20star%20power%20standing%20in%20cosmic%20void%2C%20deep%20space%20theme%20with%20nebula%20colors%2C%20navy%20and%20gold%20tones%2C%20stylized%20art%2C%20clean%20dramatic%20background&width=800&height=500&seq=article-zt-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20cosmic%20fantasy%20banner%20with%20ancient%20bronze%20coffin%20dragged%20by%20dragons%20through%20starry%20void%2C%20epic%20space%20atmosphere%2C%20deep%20navy%20and%20gold%20tones%2C%20cinematic%20stylized%20art%2C%20clean%20composition&width=1400&height=500&seq=article-zt-banner&orientation=landscape',
    tags: ['仙侠', '星空', '年番', '国产'],
  },
  {
    slug: 'xianni',
    id: 5,
    title: '仙逆',
    alias: 'Renegade Immortal',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '王林以凡人之躯逆天修行，在无尽的杀戮中寻找生的意义，顺为凡，逆则仙！',
    longDescription: '顺为凡，逆则仙，只在心中一念间。王林本是赵国一个普通木匠的儿子，因意外踏入修仙之路。在残酷的修真世界中，他凭着过人的才智与不屈的意志，逐步从底层修士成长为令整个修真界闻风丧胆的煞星。杀戮、夺舍、炼丹、阵法，他无所不精。从一个被追杀的亡命之徒，到最终掌控诸天万界的至强者，王林用一生诠释了"顺为凡，逆则仙"的真谛。',
    rating: 9.4,
    studio: '腾讯视频',
    author: '耳根',
    status: '连载中',
    updateDay: '周一',
    updateTime: '10:00',
    totalEpisodes: 96,
    currentEpisode: 72,
    episodes: makeEpisodes(72, 12, ['恒岳派', '夺舍重生', '古神之地', '天逆珠', '杀戮道', '朱雀星', '四圣器', '仙遗族', '封界之战', '轮回桥', '道古传承', '仙罡大陆']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20dark%20immortal%20cultivator%20with%20purple%20energy%20swirls%20in%20mysterious%20realm%2C%20intense%20and%20powerful%20aura%2C%20dark%20mystical%20theme%20with%20purple%20accents%2C%20stylized%20anime%20art%2C%20clean%20gradient%20background&width=800&height=500&seq=article-xn-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20dark%20fantasy%20banner%20with%20lone%20cultivator%20standing%20among%20ancient%20ruins%20under%20stormy%20purple%20sky%2C%20dramatic%20mystical%20lighting%2C%20stylized%20cinematic%20art%2C%20clean%20atmospheric%20composition&width=1400&height=500&seq=article-xn-banner&orientation=landscape',
    tags: ['修仙', '热血', '逆袭', '国产'],
  },
  {
    slug: 'yinian-yongheng',
    id: 6,
    title: '一念永恒',
    alias: 'A Will Eternal',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '白小纯追求长生不老，以独特的方式在修仙界闯出一片天地。怕死又爱出风头的主角，笑料百出。',
    longDescription: '白小纯是一个怕死到了极点的修仙者，他的终极目标是——长生不老！为了这个目标，他可以不择手段、不顾形象。烧火做饭顺便炼丹，养鸡种田顺手修炼。别人修仙是为了变强，他修仙是为了活得更久。在一次次啼笑皆非的冒险中，白小纯从一个被嫌弃的胆小鬼，成长为名震修真界的永恒存在。这是一部让人笑到停不下来的修仙喜剧！',
    rating: 9.0,
    studio: '腾讯视频',
    author: '耳根',
    status: '连载中',
    updateDay: '周三',
    updateTime: '10:00',
    totalEpisodes: 130,
    currentEpisode: 110,
    episodes: makeEpisodes(110, 12, ['灵溪宗', '血溪宗', '丹道大成', '巨鬼王', '星空道极', '永恒之花', '蛮荒之战', '通天世界', '太古雷龙', '不死卷', '大乘之路', '永恒之境']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20comedic%20cultivation%20donghua%20mischievous%20young%20man%20with%20cheeky%20smile%20holding%20pill%20furnace%2C%20bright%20and%20humorous%20style%20with%20warm%20cheerful%20tones%2C%20stylized%20art%2C%20clean%20light%20background&width=800&height=500&seq=article-ynyh-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20comedic%20fantasy%20banner%20with%20colorful%20pill%20furnaces%20and%20magical%20herbs%20in%20vibrant%20cultivation%20academy%2C%20bright%20warm%20lighting%2C%20stylized%20humorous%20art%2C%20clean%20cheerful%20atmosphere&width=1400&height=500&seq=article-ynyh-banner&orientation=landscape',
    tags: ['修仙', '搞笑', '年番', '国产'],
  },
  {
    slug: 'wudong-qiankun',
    id: 7,
    title: '武动乾坤',
    alias: 'Martial Universe',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '林动从青阳镇走出，凭借神秘石符和坚毅意志，在武道之路上步步高升，武动乾坤！',
    longDescription: '修炼一途，乃窃阴阳，夺造化，转涅槃，握生死，掌轮回。武之极，破苍穹，动乾坤！少年林动，偶然在山洞中获得一枚神秘石符，从此踏上逆天改命的武道之路。从大炎王朝到百朝大战，从东玄域到乱魔海，林动手持祖石，以天符师的独特身份，在万族争锋的乱世中杀出一条血路，最终成就武祖之名。',
    rating: 8.9,
    studio: '腾讯视频',
    author: '天蚕土豆',
    status: '连载中',
    updateDay: '周日',
    updateTime: '10:00',
    totalEpisodes: 78,
    currentEpisode: 48,
    episodes: makeEpisodes(48, 12, ['青阳镇', '石符之谜', '大炎王朝', '符师会', '涅槃境', '百朝大战', '东玄域', '祖石之秘', '乱魔海', '吞噬之主', '冰主应欢欢', '武祖之路']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20martial%20arts%20donghua%20fierce%20warrior%20with%20energy%20fist%20in%20ancient%20battlefield%2C%20earth%20tones%20and%20warm%20golden%20lighting%2C%20stylized%20art%2C%20clean%20dramatic%20background&width=800&height=500&seq=article-wdql-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20martial%20fantasy%20banner%20with%20warrior%20standing%20on%20ancient%20battlefield%20ruins%2C%20earth%20and%20gold%20energy%20swirling%2C%20dramatic%20warm%20lighting%2C%20stylized%20cinematic%20art%2C%20clean%20composition&width=1400&height=500&seq=article-wdql-banner&orientation=landscape',
    tags: ['玄幻', '热血', '武道', '国产'],
  },
  {
    slug: 'dazhuzai',
    id: 8,
    title: '大主宰',
    alias: 'The Great Ruler',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '牧尘在北灵境中崛起，立志成为盖世强者，与九幽雀为伴，踏上至尊之路。',
    longDescription: '大千世界，位面交汇，万族林立，群雄荟萃。一位位来自下位面的天之至尊，在这无尽世界演绎着令人向往的传奇。少年牧尘，资质卓绝，出生于北灵境九大域之一的牧域。他修炼神秘灵诀，与九幽雀缔结契约，一步步走向大千世界的巅峰。从天罗大陆到浮屠古族，从无尽火域到武境，牧尘追寻着成为大主宰的道路。',
    rating: 8.8,
    studio: '哔哩哔哩',
    author: '天蚕土豆',
    status: '连载中',
    updateDay: '周五',
    updateTime: '10:00',
    totalEpisodes: 52,
    currentEpisode: 36,
    episodes: makeEpisodes(36, 10, ['北灵境', '灵路试炼', '九幽雀', '五大院', '灵阵师', '龙魔宫', '浮屠古族', '无尽火域', '武境之路', '大主宰']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20donghua%20young%20lord%20with%20spiritual%20beast%20phoenix%20companion%20in%20ancient%20palace%2C%20regal%20golden%20tones%2C%20stylized%20art%2C%20clean%20majestic%20background&width=800&height=500&seq=article-dzz-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20epic%20fantasy%20banner%20with%20ancient%20golden%20palace%20and%20mythical%20phoenix%20soaring%20in%20sky%2C%20regal%20warm%20tones%2C%20stylized%20cinematic%20art%2C%20clean%20majestic%20atmosphere&width=1400&height=500&seq=article-dzz-banner&orientation=landscape',
    tags: ['玄幻', '热血', '年番', '国产'],
  },
  {
    slug: 'jianlai',
    id: 9,
    title: '剑来',
    alias: 'Sword of Coming',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '陈平安在大骊王朝的修仙冒险，一剑开天门，万古如长夜。全新3D画风，质感非凡。',
    longDescription: '大千世界，无奇不有。我陈平安，唯有一剑，可搬山，倒海，降妖，镇魔，敕神，摘星，断江，摧城，开天！一个贫苦少年，带一只小葫芦，离开小镇，踏上了充满未知的修仙之路。在泥瓶巷长大的陈平安，凭借一颗赤子之心和过人悟性，在齐静春的指引下开始修炼。从骊珠洞天到剑气长城，从天外天到蛮荒天下，他手持老剑条，以天地为师，一剑斩出属于自己的剑道。',
    rating: 9.7,
    studio: '腾讯视频',
    author: '烽火戏诸侯',
    status: '连载中',
    updateDay: '周一',
    updateTime: '10:00',
    totalEpisodes: 78,
    currentEpisode: 56,
    episodes: makeEpisodes(56, 12, ['泥瓶巷', '骊珠洞天', '齐静春', '老剑条', '剑气长城', '搬山猿', '陈平安出剑', '落魄山', '北俱芦洲', '蛮荒天下', '剑开天门', '文圣一脉']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20sword%20immortal%20standing%20on%20mountain%20peak%20with%20floating%20ancient%20swords%2C%20epic%20cinematic%20lighting%2C%20warm%20golden%20and%20white%20tones%2C%20stylized%203D%20anime%20art%2C%20clean%20dramatic%20background&width=800&height=500&seq=article-jl-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20epic%20sword%20fantasy%20banner%20with%20lone%20swordsman%20on%20cliff%20edge%20facing%20endless%20mountain%20range%20at%20sunrise%2C%20floating%20swords%20in%20sky%2C%20cinematic%20warm%20golden%20lighting%2C%20stylized%203D%20art%2C%20clean%20atmosphere&width=1400&height=500&seq=article-jl-banner&orientation=landscape',
    tags: ['仙侠', '剑道', '3D', '国产'],
  },
  {
    slug: 'mushenji',
    id: 10,
    title: '牧神记',
    alias: 'Tales of Herding Gods',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '秦牧从一个放牛娃成长为绝世强者，在残老村中与九个神秘老人展开的奇幻冒险故事。',
    longDescription: '大墟的祖训说，天黑，别出门。残老村的九个老头说，秦牧，听话，别出门。然而这一天，秦牧偏要出门。大墟的世界，远比想象中更加诡谲与广袤。在残老村中，九个神秘老人各怀神通，他们有的是曾经的剑神，有的是绝世丹师。秦牧在他们的调教下，从一个懵懂放牛娃成长为搅动天地的绝世强者，开启了一段充满奇遇与感动的修炼之旅。',
    rating: 9.5,
    studio: '哔哩哔哩',
    author: '宅猪',
    status: '连载中',
    updateDay: '周二',
    updateTime: '10:00',
    totalEpisodes: 52,
    currentEpisode: 40,
    episodes: makeEpisodes(40, 10, ['残老村', '九老传功', '大墟初探', '剑神传人', '炼丹入门', '天魔众', '秦牧出剑', '龙麒麟', '延康国', '牧神之路']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20pastoral%20fantasy%20boy%20with%20mysterious%20elders%20in%20ancient%20village%2C%20warm%20sunset%20lighting%20with%20magical%20glow%2C%20stylized%20anime%20art%2C%20clean%20peaceful%20background&width=800&height=500&seq=article-msj-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20pastoral%20fantasy%20banner%20with%20ancient%20village%20nestled%20in%20mystical%20valley%2C%20warm%20sunset%20golden%20light%2C%20magical%20atmosphere%20with%20floating%20particles%2C%20stylized%20cinematic%20art%2C%20clean%20serene%20composition&width=1400&height=500&seq=article-msj-banner&orientation=landscape',
    tags: ['仙侠', '冒险', '成长', '国产'],
  },
  {
    slug: 'yuanzun',
    id: 11,
    title: '元尊',
    alias: 'Dragon Prince Yuan',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '周元身怀圣龙气运，却被他人窃取。且看他如何逆天改命，重掌乾坤，踏上巅峰之路。',
    longDescription: '天地为炉，万物为铜，阴阳为炭，造化为工。气运之争，蟒雀吞龙。周元本是周家皇子，身怀圣龙气运，却被敌国以阴谋窃取。气运被夺的他，从云端跌落谷底。但周元不甘为凡，凭借自身努力和际遇，与天争命，一步步重掌圣龙气运，最终踏上武道巅峰，成为一代元尊。这是一个关于不屈与逆袭的故事！',
    rating: 9.1,
    studio: '腾讯视频',
    author: '天蚕土豆',
    status: '连载中',
    updateDay: '周四',
    updateTime: '10:00',
    totalEpisodes: 52,
    currentEpisode: 38,
    episodes: makeEpisodes(38, 10, ['圣龙气运', '蟒雀吞龙', '苍茫大陆', '源纹师', '天渊域', '混元天', '四圣纹', '圣者之路', '阴阳气府', '元尊归来']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20young%20prince%20with%20dragon%20spirit%20energy%20in%20ancient%20palace%2C%20regal%20golden%20and%20crimson%20tones%2C%20stylized%20anime%20art%2C%20clean%20majestic%20background&width=800&height=500&seq=article-yz-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20regal%20fantasy%20banner%20with%20young%20prince%20and%20golden%20dragon%20spirit%20in%20ancient%20palace%20hall%2C%20majestic%20warm%20crimson%20and%20gold%20lighting%2C%20stylized%20cinematic%20art%2C%20clean%20composition&width=1400&height=500&seq=article-yz-banner&orientation=landscape',
    tags: ['玄幻', '逆袭', '年番', '国产'],
  },
  {
    slug: 'xingchenbian',
    id: 12,
    title: '星辰变',
    alias: 'Stellar Transformation',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '秦羽不甘平凡，修炼外功成就传奇。流星泪降临，星辰变功法开启全新宇宙篇章。',
    longDescription: '秦羽是秦王朝的三世子，因天生无法修炼内功而被父亲冷落。但他不甘平凡，毅然选择了最艰苦的外功修炼之路。在得到流星泪后，他与小黑（黑鹰）一同踏上了修真之路。从天罚功法到星辰变，从凡人界到仙魔妖界，再到神界，秦羽创造出属于自己的传奇。这是一部跨越星河的修真史诗！',
    rating: 9.3,
    studio: '腾讯视频',
    author: '我吃西红柿',
    status: '连载中',
    updateDay: '周五',
    updateTime: '12:00',
    totalEpisodes: 104,
    currentEpisode: 88,
    episodes: makeEpisodes(88, 12, ['外功之路', '流星泪', '星辰变', '凡人界', '仙魔妖界', '暗星界', '神界之旅', '天尊山', '宇宙之主', '鸿蒙空间', '林蒙宇宙', '星辰大成']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20cosmic%20cultivation%20warrior%20surrounded%20by%20stars%20and%20nebula%20in%20deep%20space%2C%20ethereal%20blue%20and%20purple%20cosmic%20theme%2C%20stylized%20anime%20art%2C%20clean%20celestial%20background&width=800&height=500&seq=article-xcb-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20cosmic%20fantasy%20banner%20with%20warrior%20floating%20among%20galaxies%20and%20star%20systems%2C%20nebula%20colors%2C%20deep%20space%20aesthetic%2C%20stylized%20cinematic%20art%2C%20clean%20ethereal%20atmosphere&width=1400&height=500&seq=article-xcb-banner&orientation=landscape',
    tags: ['修仙', '星空', '年番', '国产'],
  },
  {
    slug: 'wangu-shendi',
    id: 13,
    title: '万古神帝',
    alias: 'Eternal God Emperor',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '张若尘从八百年后穿越归来，带着前世记忆重新踏上武道之路，纵横万古诸天。',
    longDescription: '八百年后，张若尘重生于十六岁的少年时代。前世，他是昆仑界的九皇子，被未婚妻池瑶公主在婚礼上杀害。如今重生归来，他带着前世八百年的记忆和战斗经验，重新踏入武道修炼之路。这一世，他不再信任任何人，誓要查清当年的真相。从黄极境到天极境，从圣者到大圣，张若尘一步步揭开万古以来最大的秘密。',
    rating: 9.2,
    studio: '优酷',
    author: '飞天鱼',
    status: '连载中',
    updateDay: '周二',
    updateTime: '12:00',
    totalEpisodes: 78,
    currentEpisode: 52,
    episodes: makeEpisodes(52, 12, ['重生归来', '时空秘典', '武道四境', '池瑶公主', '圣者之路', '昆仑界', '大圣之境', '天堂界', '地狱界', '时空掌控', '万古之秘', '神帝归来']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20reincarnated%20warrior%20in%20ancient%20oriental%20city%20at%20night%2C%20mysterious%20and%20powerful%20aura%2C%20warm%20amber%20and%20gold%20tones%2C%20stylized%20anime%20art%2C%20clean%20atmospheric%20background&width=800&height=500&seq=article-wgsd-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20fantasy%20banner%20with%20reborn%20warrior%20overlooking%20ancient%20oriental%20city%20at%20twilight%2C%20mysterious%20golden%20energy%2C%20dramatic%20warm%20amber%20lighting%2C%20stylized%20cinematic%20art%2C%20clean%20atmosphere&width=1400&height=500&seq=article-wgsd-banner&orientation=landscape',
    tags: ['玄幻', '重生', '复仇', '国产'],
  },
  {
    slug: 'tunshi-xingkong',
    id: 14,
    title: '吞噬星空',
    alias: 'Swallowed Star',
    category: '国产动漫',
    categorySlug: 'guoman',
    description: '罗峰在怪兽横行的未来世界，一步步从武者成长为宇宙之主，开启星辰大海的征程。',
    longDescription: '在未来的世界里，地球经历了大涅槃时期，怪兽横行，人类建立了基地市来抵御怪兽的入侵。罗峰是一个普通的高中生，但他有着一颗不甘平凡的心。在成为武者之后，他得到了陨墨星主人的传承，一步步从地球走向宇宙。从行星级到恒星级，从宇宙级到域主级，最终成为掌控者。这是一部融合了科幻与修炼元素的史诗巨作！',
    rating: 9.6,
    studio: '腾讯视频',
    author: '我吃西红柿',
    status: '连载中',
    updateDay: '周三',
    updateTime: '12:00',
    totalEpisodes: 130,
    currentEpisode: 108,
    episodes: makeEpisodes(108, 12, ['武者考核', '陨墨星传承', '地球最强', '踏入宇宙', '黑龙山帝国', '宇宙天才战', '域主之路', '界主之境', '原始宇宙', '宇宙海', '起源大陆', '掌控者']),
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20sci%20fi%20power%20armor%20warrior%20fighting%20monsters%20in%20futuristic%20cyberpunk%20city%2C%20dynamic%20action%20with%20energy%20weapons%2C%20stylized%20anime%20art%2C%20clean%20cinematic%20background&width=800&height=500&seq=article-tsxk-01&orientation=landscape',
    bannerImage: 'https://readdy.ai/api/search-image?query=Wide%20Chinese%20donghua%20sci%20fi%20banner%20with%20futuristic%20city%20under%20alien%20invasion%2C%20power%20armor%20warrior%20in%20foreground%2C%20cinematic%20action%20scene%2C%20neon%20and%20warm%20orange%20lighting%2C%20stylized%20art%2C%20clean%20dramatic%20composition&width=1400&height=500&seq=article-tsxk-banner&orientation=landscape',
    tags: ['科幻', '热血', '年番', '国产'],
  },
];

export const articlesBySlug: Record<string, AnimeArticle> = {};
export const articlesById: Record<number, AnimeArticle> = {};

allArticles.forEach((article) => {
  articlesBySlug[article.slug] = article;
  articlesById[article.id] = article;
});

export function getArticleBySlug(slug: string): AnimeArticle | undefined {
  return articlesBySlug[slug];
}

export function getArticleById(id: number): AnimeArticle | undefined {
  return articlesById[id];
}

export function getArticlesByCategory(categorySlug: string): AnimeArticle[] {
  return allArticles.filter((a) => a.categorySlug === categorySlug);
}

export function getRelatedArticles(article: AnimeArticle, count: number = 4): AnimeArticle[] {
  return allArticles
    .filter((a) => a.slug !== article.slug)
    .sort(() => 0.5 - Math.random())
    .slice(0, count);
}